export enum InputTags {
  PRIMARY = 'primary',
  STANDARD = 'standard',
}
